import { getDownloadURL, getStorage, ref } from 'firebase/storage';
import { firebaseApp } from './app';

/**
 * Resolves a Storage path (the only thing Firestore holds for an image) to a
 * URL the browser can render. `getDownloadURL` is an authenticated call that
 * enforces storage.rules, which is the whole reason paths are stored rather
 * than URLs — see the hotel app's `services/storage.js`.
 *
 * Cached per path for the life of the page: a menu of a hundred dishes must
 * not resolve the same thumbnail every time a category tab is switched.
 */
const cache = new Map<string, Promise<string>>();

export function resolveStorageUrl(path: string): Promise<string> {
  let pending = cache.get(path);
  if (!pending) {
    pending = getDownloadURL(ref(getStorage(firebaseApp()), path)).catch((error) => {
      cache.delete(path);
      throw error;
    });
    cache.set(path, pending);
  }
  return pending;
}
